import { createMiddleware } from "@tanstack/react-start";
import { getRequest, setResponseStatus } from "@tanstack/react-start/server";
import { auth } from "~/lib/auth/server";

// https://tanstack.com/start/latest/docs/framework/react/middleware
// This is a sample middleware that you can use in your server functions.

/**
 * Middleware to force authentication on a server function, and add the user to the context.
 */
export const authMiddleware = createMiddleware().server(async ({ next }) => {
  const session = await auth.api.getSession({
    headers: getRequest().headers,
    query: {
      // ensure session is fresh
      // https://www.better-auth.com/docs/concepts/session-management#session-caching
      disableCookieCache: true,
    },
  });

  if (!session) {
    setResponseStatus(401);
    throw new Error("Unauthorized");
  }

  return next({ context: { user: session.user } });
});

/**
 * Optional auth middleware — resolves session if available, but does not block unauthenticated requests.
 */
export const optionalAuthMiddleware = createMiddleware().server(
  async ({ next }) => {
    const session = await auth.api.getSession({
      headers: getRequest().headers,
    });

    return next({ context: { user: session?.user ?? null } });
  }
);
